export default __webpack_public_path__ + "static/media/ff-screenshot-1.6badbabf.png";